import React from 'react'
import Hero from './Hero'
import About from './About'
import Experience from './Experience'
import Tech from './Tech'

function Home() {
  return (
    <div>
        <Hero />
        <About/>
        <Experience/>
        <Tech/>
    </div> 
  )
}

export default Home